<template>
    <Page class="drinks-page menu-page">
        <ContentDoc v-slot="content">
            <div class="menu-category" v-for="category in content.doc.body" :key="category.category"
                :style="`--category-colorx: ${category.color}`">
                <div class="menu-category__title">
                    <h2>{{ category.category }}</h2>
                </div>
                <div class="menu-item --sizes">
                    <div class="menu-item__header">
                        <h3 class="menu-item__name"></h3>
                        <div class="link-line" />
                        <h4 v-for="size in categorySizes(category)" :key="size" class="menu-item__price --header">{{
            size }}</h4>
                    </div>
                </div>
                <div class="menu-item" v-for="drink in category.drinks" :key="drink.name">
                    <div class="menu-item__header">
                        <h3 class="menu-item__name">{{ drink.name }}</h3>

                        <div class="link-line" />
                        <h4 v-for="size in categorySizes(category)" :key="size" class="menu-item__price">
                            {{ drink.prices[size] || "-" }}
                        </h4>
                    </div>
                    <div class="menu-item__description">{{ drink.description }}</div>
                </div>
            </div>
        </ContentDoc>
    </Page>
</template>

<script>
export default {
    methods: {
        categorySizes(category) {
            console.log(category)
            const { drinks } = category
            const sizes = drinks.reduce((acc, drink) => {
                const { prices } = drink
                const drinkSizes = Object.keys(prices)
                console.log(category.category, acc, drinkSizes)
                drinkSizes.forEach(size => {
                    if (!acc.includes(size)) {
                        acc.push(size)
                    }
                })
                return acc
            }, [])
            console.log(category.category, sizes)
            return sizes
        }
    }
}
</script>